import { useState } from 'react';
import { BackBar, Chip, Card, PrimaryBtn, AIOutput, WhatsAppBtn, useCoachStream } from './healthShared';

const PLACES = ['Home', 'Gym', 'No equipment'];
const GOALS = ['Weight loss', 'Strength', 'Fitness', 'Mobility'];

export default function MoveSection({ onBack }) {
  const [mins, setMins] = useState(10);
  const [place, setPlace] = useState('No equipment');
  const [goal, setGoal] = useState('Fitness');
  const { output, running, run, stop } = useCoachStream();

  const generate = () => {
    run(`Give me a ${mins}-minute workout. Location: ${place}. Goal: ${goal}. I'm a busy doctor — keep it simple and doable.`, 'workout');
  };

  return (
    <div data-testid="move-section">
      <BackBar title="Move" onBack={onBack} />
      <p className="text-sm text-[#66735F] mb-5 -mt-2">Quick workouts for busy doctors. 10 minutes counts.</p>

      <Card className="p-5 space-y-5">
        <div>
          <p className="text-xs font-black tracking-widest uppercase text-[#7FA183] mb-2">How much time?</p>
          <div className="grid grid-cols-3 gap-2">
            {[10, 20, 30].map((m) => (
              <button
                key={m}
                onClick={() => setMins(m)}
                data-testid={`move-mins-${m}`}
                className={`py-5 rounded-2xl font-accent text-2xl transition-colors border-2 ${
                  mins === m ? 'bg-[#2E4A3B] text-white border-[#2E4A3B] shadow-lg' : 'bg-white text-[#2E4A3B] border-[#E3E5D8] hover:border-[#9DB8A0]'
                }`}
              >
                {m}<span className="text-xs font-body font-bold tracking-wide block mt-0.5">MIN</span>
              </button>
            ))}
          </div>
          {mins === 10 && <p className="text-[11px] text-[#D97B5A] font-bold mt-2">⚡ The signature Gynovate Health 10-minute workout</p>}
        </div>
        <div>
          <p className="text-xs font-black tracking-widest uppercase text-[#7FA183] mb-2">Where?</p>
          <div className="flex flex-wrap gap-2">
            {PLACES.map((p) => <Chip key={p} active={place === p} onClick={() => setPlace(p)} testId={`move-place-${p.toLowerCase().replace(/\s/g, '-')}`}>{p}</Chip>)}
          </div>
        </div>
        <div>
          <p className="text-xs font-black tracking-widest uppercase text-[#7FA183] mb-2">Goal</p>
          <div className="flex flex-wrap gap-2">
            {GOALS.map((g) => <Chip key={g} active={goal === g} onClick={() => setGoal(g)} testId={`move-goal-${g.toLowerCase().replace(/\s/g, '-')}`}>{g}</Chip>)}
          </div>
        </div>
        {running ? (
          <PrimaryBtn onClick={stop} testId="move-stop-btn" className="w-full py-4 bg-[#A85A3E]">Stop</PrimaryBtn>
        ) : (
          <PrimaryBtn onClick={generate} testId="move-generate-btn" className="w-full py-4 text-base">GET MY {mins}-MIN WORKOUT</PrimaryBtn>
        )}
      </Card>

      {(output || running) && (
        <Card className="p-5 mt-4" testId="workout-output-card">
          {running && !output && <p className="text-sm text-[#9AA594] animate-pulse">Building your workout…</p>}
          <AIOutput text={output} testId="workout-output" />
          {!running && output && <div className="mt-4"><WhatsAppBtn text={output} testId="workout-whatsapp-btn" /></div>}
        </Card>
      )}
    </div>
  );
}
